import HEART_NFT_ABI from '../../../constants/abis/nft-heart.json'
import { HEARTS_NFT_ADDRESS } from "../../../constants";
import heartBeatsGIF from '../../../assets/images/heartBeatsGIF.gif'


export interface ISaleItem {
    name: string;
    ABI: any,
    Addresses: any,
    description: string,
    title: string,
    subTitle: string,
    imgUrl: string,
    saleDate: number,
    totalSupply: number,
    twitter?: string,
    telegram?: string,
    discord?: string,
    website?: string
}
//0x07a752bB93BaE13f05b957d2F5e8B50B2f39169D/53
export const SaleList: { [name: string]: ISaleItem } = {
    "heartBeats": {
        name: "heartBeats",
        ABI: HEART_NFT_ABI,
        Addresses: HEARTS_NFT_ADDRESS,
        title: "Heart Beats NFT Collection",
        subTitle: "A collection of 101 unique HeartBeat NFTs on Avalanche.",
        imgUrl: heartBeatsGIF,
        saleDate: 1645984800000,
        totalSupply: 101,
        description: "I'm Mert Dolapçıoğlu. I was born in 1997. For years, I drew in humor magazines. I'm still drawing. In this collection, I made a series of the heart, which is one of my favorite subjects, and the different moods it reflects on us. The voice of our heart manages to make itself heard even in the loudest places. Let's listen to the voice of the heart together.",
        twitter: "https://twitter.com/mertdolapcioglu"
    },
    // "roboClash": {
    //     name: "roboClash",
    //     ABI: HEART_NFT_ABI,
    //     Addresses: HEARTS_NFT_ADDRESS,
    //     title: "RoboClash NFTs",
    //     subTitle: "CRAFT - EQUIP - FIGHT",
    //     imgUrl: "https://roboclash.io/images/RoboClash-logo-icon.svg",
    //     saleDate: 1645984800000,
    //     totalSupply: 1000,
    //     description: "RoboClash is an NFT-based game with a Play-To-Earn structure where you can earn coins and in-game rewards by fighting in Daily Missions and PVP. Craft your items for more-rare NFTs or bring along your friends to earn even more rewards.",
    //     twitter: "https://twitter.com/yetiswap",
    //     telegram: "https://t.me/yetiswap",
    //     discord: "https://discord.gg/yetiswap",
    //     website: "https://yetiswap.com"
    // }
}

export const getSaleFromName = (name: string) => {
    let sale = SaleList[name];
    return sale;
}
